import { ChangelogAPI } from '@business/api/changelog';
import { ChangelogId, ChangelogRequest, ChangelogResponse } from '@business/entities/changelog';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { R } from '@core/utils/r';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap } from 'rxjs/operators';

export class ChangelogBloc extends BaseBloc {
  private readonly changelogRepo = new Repository<ChangelogResponse>({
    getItemId: changelog => changelog.id,
  });

  readonly changelogs$ = this.changelogRepo.items$.pipe(map(logs => R.orderBy(logs, 'created', 'desc')));
  readonly selectChangelog = this.changelogRepo.selectItem;

  onReset() {
    this.changelogRepo.reset();
  }

  fetchChangelogs = () => {
    return ChangelogAPI.fetchChangelogs().pipe(this.changelogRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_changelogs_error') }));
  };

  fetchChangelog = (id: ChangelogId) => {
    return ChangelogAPI.fetchChagelog(id).pipe(
      this.changelogRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_changelogs_error') }),
    );
  };

  createChangelog = (changelog: ChangelogRequest) => {
    return ChangelogAPI.createChangelog(changelog).pipe(
      this.changelogRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_changelog'),
      }),
    );
  };

  updateChangelog = (id: ChangelogId, changelog: ChangelogRequest) => {
    return ChangelogAPI.updateChangelog(id, changelog).pipe(
      this.changelogRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_changelog'),
      }),
    );
  };

  deleteChangelog = (id: ChangelogId) => {
    return showDeleteConfirmation('Delete Changelog', 'Do you really want to remove this changelog?').pipe(
      switchMap(() => ChangelogAPI.deleteChangelog(id)),
      this.changelogRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_changelog'),
      }),
    );
  };
}
